var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4C6.91015 4 4 6.91015 4 10.5C4 11.5188 4.2337 12.4803 4.64948 13.3361C5.01873 14.0962 5.18385 15.0585 4.83274 15.9852L4.44826 17H10.5C14.0899 17 17 14.0899 17 10.5C17 6.91015 14.0899 4 10.5 4ZM2 10.5C2 5.80558 5.80558 2 10.5 2C15.1944 2 19 5.80558 19 10.5C19 15.1944 15.1944 19 10.5 19H3.72413C2.67465 19 1.9496 17.9499 2.32144 16.9685L2.96249 15.2766C3.06983 14.9933 3.0467 14.6139 2.85053 14.2101C2.30532 13.0878 2 11.8281 2 10.5ZM21 11.9999C21.5523 11.9999 22 12.4476 22 12.9999C22 13.8169 21.7327 14.6269 21.4214 15.3073C21.1046 15.9998 20.7067 16.6336 20.3697 17.1175C20.1079 17.4936 20.0533 17.9258 20.181 18.2629L20.6786 19.5761C21.0504 20.5575 20.3254 21.6076 19.2759 21.6076H13C12.4477 21.6076 12 21.1599 12 20.6076C12 20.0553 12.4477 19.6076 13 19.6076H18.5517L18.3107 18.9715C17.9156 17.9286 18.1471 16.8096 18.7284 15.9747C19.025 15.5488 19.3525 15.0221 19.6028 14.4752C19.8585 13.9162 20 13.408 20 12.9999C20 12.4476 20.4477 11.9999 21 11.9999Z",
    fill: "#9397A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1e0171707fdaa7dcc151fe61af24ef3e.svg";
export { ForwardRef as ReactComponent };